import { render, staticRenderFns } from "./ModalFrame.vue?vue&type=template&id=6aa7f778&scoped=true"
import script from "./ModalFrame.vue?vue&type=script&lang=ts"
export * from "./ModalFrame.vue?vue&type=script&lang=ts"
import style0 from "./ModalFrame.vue?vue&type=style&index=0&id=6aa7f778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa7f778",
  null
  
)

export default component.exports